import React from 'react';

/**
 * Гільйошна розета — той візерунок із тонких ліній, який друкують на бланках
 * ліцензій, дипломів і сертифікатів, щоб їх не можна було просто скопіювати.
 *
 * Для юридичної компанії, чия робота закінчується саме такими документами,
 * це не абстрактна прикраса, а знак ремесла. На місці цієї розети раніше
 * стояло слово «VMG» сірим кеглем 128px, повернуте на 12 градусів, — прийом,
 * який стоїть на кожному другому корпоративному сайті.
 *
 * Малюється без жодного файлу й без математики в рантаймі: розета — це просто
 * три десятки однакових еліпсів, повернутих на рівний крок навколо спільного
 * центру. Перетини їхніх контурів і дають той муар, який здається складним
 * малюнком. Півкола досить: еліпс симетричний, тож поворот на 180° уже
 * замикає фігуру.
 *
 * Колір береться з тексту, прозорість задає той, хто ставить, — розета має
 * лишатися тлом, а не сперечатися з текстом поруч.
 */

const ring = (count, rx, ry) =>
  Array.from({ length: count }, (_, i) => (
    <ellipse
      key={`${rx}-${i}`}
      cx="200"
      cy="200"
      rx={rx}
      ry={ry}
      transform={`rotate(${(180 / count) * i} 200 200)`}
    />
  ));

const Guilloche = ({ className }) => (
  <svg
    viewBox="0 0 400 400"
    className={className}
    fill="none"
    stroke="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    {/* Обідок: дві кола різної товщини, як на печатці. */}
    <g strokeWidth="1.2">
      <circle cx="200" cy="200" r="192" />
    </g>
    <g strokeWidth="0.5">
      <circle cx="200" cy="200" r="183" />
    </g>

    {/* Зовнішня розета */}
    <g strokeWidth="0.6">{ring(30, 168, 62)}</g>

    {/* Внутрішня, дрібніша — вона й створює згущення до центру */}
    <g strokeWidth="0.5">{ring(20, 96, 34)}</g>

    <g strokeWidth="0.8">
      <circle cx="200" cy="200" r="26" />
    </g>
  </svg>
);

export default Guilloche;
